import { useEffect, useRef, useState } from 'react'
import { CalendarDots } from '@phosphor-icons/react/dist/ssr/CalendarDots'
import { Check } from '@phosphor-icons/react/dist/ssr/Check'
import { CopySimple } from '@phosphor-icons/react/dist/ssr/CopySimple'
import { TelegramLogo } from '@phosphor-icons/react/dist/ssr/TelegramLogo'
import { WhatsappLogo } from '@phosphor-icons/react/dist/ssr/WhatsappLogo'
import { siteConfig } from '../../config/site'
import './site-layout.css'
import './portfolio-footer.css'

export function PortfolioContactLinks() {
  const [copyState, setCopyState] = useState<'idle' | 'copied' | 'failed'>('idle')
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  useEffect(() => () => clearTimeout(timer.current), [])

  async function copyEmail() {
    clearTimeout(timer.current)
    try {
      await navigator.clipboard.writeText(siteConfig.contactEmail)
      setCopyState('copied')
      timer.current = setTimeout(() => setCopyState('idle'), 2000)
    } catch {
      setCopyState('failed')
    }
  }

  return <>
    <div className="portfolio-contact-links">
      <div className="portfolio-contact-group">
        <a className="portfolio-contact portfolio-contact-telegram" href={siteConfig.telegramUrl} target="_blank" rel="noreferrer" aria-label="Telegram (opens in new tab)"><TelegramLogo size={16} weight="fill" aria-hidden="true" /><span>Telegram</span></a>
        <a className="portfolio-contact portfolio-contact-whatsapp" href={siteConfig.whatsappUrl} target="_blank" rel="noreferrer" aria-label="WhatsApp (opens in new tab)"><WhatsappLogo size={16} weight="fill" aria-hidden="true" /><span>Whatsapp</span></a>
      </div>
      <div className="portfolio-contact-group">
        <button className="portfolio-contact portfolio-contact-copy" type="button" onClick={copyEmail} aria-label={copyState === 'copied' ? 'Email copied' : 'Copy email address'}>{copyState === 'copied' ? <Check size={16} aria-hidden="true" /> : <CopySimple size={16} aria-hidden="true" />}<span aria-live="polite">{copyState === 'copied' ? 'Copied' : 'Copy Email'}</span></button>
        <a className="portfolio-contact" href={siteConfig.calendlyUrl} target="_blank" rel="noreferrer" aria-label="Schedule a call (opens in new tab)"><CalendarDots size={16} aria-hidden="true" /><span>Schedule a call</span></a>
      </div>
    </div>
    {copyState === 'failed' && <p className="portfolio-contact-fallback" role="status"><a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a></p>}
  </>
}

export function PortfolioFooter({ className = '' }: { className?: string }) {
  return <footer className={`portfolio-footer ${className}`}>
    <PortfolioContactLinks />
    <p>Gosha. Made by Svetlana &amp; Juri in Tallinn, <span className="portfolio-footer-place">Estonia 🇪🇪🇪🇺</span></p>
  </footer>
}
